import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../Services/Auth.service';
import { Router } from '@angular/router';
import { EmbryoService } from '../../Services/Embryo.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'embryo-HeaderUserProfileDropdown',
  templateUrl: './HeaderUserProfileDropdown.component.html',
  styleUrls: ['./HeaderUserProfileDropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserProfileDropdownComponent implements OnInit {

   constructor(public authService:AuthService, private embryoService:EmbryoService, public router:Router, translate:TranslateService) { 
   }

   ngOnInit() {
   }

  public logout(){
    this.embryoService.closeCartSubscription();
    this.embryoService.clearLocalCart();
    this.authService.logout();
    
  }
}
